import script from "./FiltersList.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersList.vue?vue&type=script&setup=true&lang=js"

import "./FiltersList.vue?vue&type=style&index=0&id=53ff7a81&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ff7a81"]])

export default __exports__